import {
  Image,
  Mail,
  MapPin,
  PenTool,
  PenLine,
  Search,
  Languages,
  Calculator,
  ShieldCheck,
  Database,
  Wrench,
  CreditCard,
  Megaphone,
  LayoutTemplate,
  Clapperboard,
  Signpost,
  UtensilsCrossed,
  FileText,
  Presentation,
  Package,
  type LucideIcon,
} from 'lucide-react'

/** Maps each addon id (shared between the main + existing-site calculators, `wd-` prefix stripped) to a lucide icon — replaces the live site's Tabler icon classes (`ti-photo`, `ti-mail`, etc.), which aren't available in this project (lucide-react is, per package.json). */
export const ADDON_ICONS: Record<string, LucideIcon> = {
  gallery: Image,
  contactform: Mail,
  maps: MapPin,
  logo: PenTool,
  copy: PenLine,
  seo: Search,
  lang: Languages,
  calc: Calculator,
  admin: ShieldCheck,
  db: Database,
  maintenance: Wrench,
}

/** Strips a leading `wd-` prefix so the existing-site calculator's ids resolve against the same icon map as the main calculator. */
export function iconForId(id: string): LucideIcon {
  const key = id.startsWith('wd-') ? id.slice(3) : id
  return ADDON_ICONS[key] ?? PenLine
}

/** Maps each `GRAFIKA_ITEMS` id to a lucide icon shown on its card. */
export const GRAFIKA_ICONS: Record<string, LucideIcon> = {
  logo: PenTool,
  card: CreditCard,
  poster: Image,
  banner: Megaphone,
  cover: LayoutTemplate,
  story: Clapperboard,
  road: Signpost,
  menu: UtensilsCrossed,
  letterhead: FileText,
  presentation: Presentation,
  packaging: Package,
}

export function iconForGrafika(id: string): LucideIcon {
  return GRAFIKA_ICONS[id] ?? Image
}
